import axios from 'axios';

// "Medir" (Inicio de la cámara): calibración y medidas guardadas por cámara (lisual-admin-backend, /api/medir).
// En local se apunta a un backend propio con REACT_APP_MEDIR_API_URL (datos en un JSON de la PC).
const BASE = (process.env.REACT_APP_MEDIR_API_URL || process.env.REACT_APP_BACKEND_URL || 'http://localhost:8081').replace(/\/$/, '');
const api = axios.create({ baseURL: `${BASE}/api/medir`, timeout: 20000 });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authLisualToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const errorMedir = (e) => e?.response?.data?.message || (e?.code === 'ERR_NETWORK' ? 'No hay conexión con el servidor' : e?.message) || 'Algo salió mal';

const id = (feedId) => encodeURIComponent(feedId);
export const leerMediciones = (feedId) => api.get(`/${id(feedId)}`).then((r) => r.data);
export const guardarCalibracion = (feedId, cal) => api.put(`/${id(feedId)}/calibracion`, cal).then((r) => r.data);
export const guardarMedida = (feedId, m) => api.post(`/${id(feedId)}/medidas`, m).then((r) => r.data);
export const renombrarMedida = (feedId, medidaId, nombre) => api.patch(`/${id(feedId)}/medidas/${encodeURIComponent(medidaId)}`, { nombre }).then((r) => r.data);
export const borrarMedida = (feedId, medidaId) => api.delete(`/${id(feedId)}/medidas/${encodeURIComponent(medidaId)}`).then((r) => r.data);

/** URL sin la firma: identifica la foto sin guardar credenciales */
export const refDeUrl = (url) => String(url || '').split('?')[0].split('#')[0];
